import { actions } from './transaction/actions'

export default {
    namespaced: true,
    actions
}
